import { useRoute } from "@react-navigation/core";
import React from "react";
import WebView from "react-native-web-webview";
import commonStyles from "../styles/commonStyles";

const DocReader = props => {
	const route = useRoute();
	const uri = props?.uri || route.params?.uri;

	const { bgColor1, flex1 } = commonStyles;

	return (
		<WebView
			style={[flex1, bgColor1]}
			bounces={false}
			scrollEnabled={false}
			source={{ uri }}
		/>
	);
};

export default DocReader;
